// https://www.npmjs.com/package/react-select-search
// npm library used for dropdown

import _ from "lodash";
import React, { useEffect, useState } from "react";
import SelectSearch, {  fuzzySearch } from "react-select-search";
import "./Searchable-Dropdown.scss";

interface SearchableDropdownProps {
  options: any;
  value: string;
  placeholder?: string;
  onChange: any;
  isSiteDropDown?: any;
}
const SearchableDropdown: React.FunctionComponent<SearchableDropdownProps> = (
  props: SearchableDropdownProps
) => {
  const [options, setOptions]: any = useState([]);

  useEffect(() => {
    if (_.isEmpty(props.options)) {
      setOptions([{ name: "no data", id: "0" }]);
    } else {
      setOptions(props.options);
    }
  }, [props.options]);

  return (
    <SelectSearch
      search={true}
      options={options}
      value={props.value}
      placeholder={props.placeholder}
      filterOptions={fuzzySearch}
      className="select-search"
      onChange={props.onChange}
      emptyMessage={
        props.isSiteDropDown
          ? "Searched site is not part of the Nserix."
          : "No data"
      }
    />
  );
};

export default SearchableDropdown;
